module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/IE-eae814f69d14a5a04c695807e7463b7c.png";